module.exports = __webpack_public_path__ + "img/intesa-bg.4d1ebef4.jpg";